import { useState } from "react";
import { ThumbsUp, ThumbsDown, Check } from "lucide-react";
import { toast } from "sonner";
import { voteFaq } from "@/lib/api";

export const VotePanel = ({ faq, onVoted }) => {
  const key = `vote-${faq.slug}`;
  const [voted, setVoted] = useState(localStorage.getItem(key));
  const [busy, setBusy] = useState(false);

  const vote = async (helpful) => {
    setBusy(true);
    try {
      const updated = await voteFaq(faq.slug, helpful);
      localStorage.setItem(key, helpful ? "yes" : "no");
      setVoted(helpful ? "yes" : "no");
      onVoted(updated);
      toast.success(helpful ? "Thanks! Glad that helped." : "Thanks for the feedback - try asking our AI Mechanic for more detail.");
    } catch {
      toast.error("Couldn't record your vote. Try again.");
    }
    setBusy(false);
  };

  const total = faq.helpful_yes + faq.helpful_no;
  const pct = total ? Math.round((faq.helpful_yes / total) * 100) : 0;
  const btn = "inline-flex items-center justify-center gap-2 px-5 h-11 rounded-sm border font-display font-bold uppercase tracking-wide transition-colors duration-200 disabled:opacity-50 active:scale-95";

  return (
    <div className="bg-[#13171F] border border-[#27303E] rounded-sm p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-5" data-testid="vote-panel">
      <div>
        <p className="font-display text-xl sm:text-2xl font-bold uppercase">Was this helpful?</p>
        <p className="text-sm text-slate-400 mt-1" data-testid="vote-stats">
          {total ? `${pct}% of ${total} drivers found this helpful` : "Be the first to rate this answer"}
        </p>
      </div>
      {voted ? (
        <p className="inline-flex items-center gap-2 text-emerald-400 font-mono text-sm uppercase tracking-wider" data-testid="vote-thanks">
          <Check size={16} /> You voted {voted === "yes" ? "helpful" : "not helpful"}
        </p>
      ) : (
        <div className="grid grid-cols-2 sm:flex gap-3">
          <button disabled={busy} onClick={() => vote(true)} data-testid="vote-helpful-yes-btn" className={`${btn} border-emerald-500/50 text-emerald-400 hover:bg-emerald-500 hover:text-[#0B0D10]`}>
            <ThumbsUp size={16} /> Yes ({faq.helpful_yes})
          </button>
          <button disabled={busy} onClick={() => vote(false)} data-testid="vote-helpful-no-btn" className={`${btn} border-[#27303E] text-slate-300 hover:bg-red-500 hover:border-red-500 hover:text-white`}>
            <ThumbsDown size={16} /> No ({faq.helpful_no})
          </button>
        </div>
      )}
    </div>
  );
};
